import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyPayment } from '../../Api/Api';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { MdCheckCircle, MdError } from 'react-icons/md';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Verifying your payment...');
  const [statusType, setStatusType] = useState('loading'); // 'loading', 'success', 'fail'
  const navigate = useNavigate();

  useEffect(() => {
    const txnid = searchParams.get('txnid');
    const status = searchParams.get('status');

    if (txnid && status === 'success') {
      verifyPayment(txnid, status)
        .then((data) => {
          if (data.success) {
            setStatusType('success');
            setMessage('🎉 Payment successful! Your order is confirmed.');
          } else {
            setStatusType('fail');
            setMessage('Payment was successful, but failed to update your order.');
          }
          setTimeout(() => {
            navigate('/');
          }, 3000);
        })
        .catch(() => {
          setStatusType('fail');
          setMessage('❌ Error verifying your payment with the server.');
        });
    } else {
      setStatusType('fail');
      setMessage('Invalid or missing transaction details.');
    }
  }, [searchParams]);

  const renderIcon = () => {
    if (statusType === 'loading') {
      return (
        <AiOutlineLoading3Quarters className="text-blue-500 animate-spin text-4xl mb-2" />
      );
    }
    if (statusType === 'success') {
      return <MdCheckCircle className="text-green-500 text-5xl mb-2 mx-auto block" />;
    }
    return <MdError className="text-red-500 text-5xl mb-2" />;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white shadow-lg rounded-xl p-8 max-w-md w-full text-center">
        {renderIcon()}
        <h2 className="text-xl font-semibold text-gray-700">{message}</h2>
        <p className="mt-4 text-sm text-gray-500">You will be redirected shortly...</p>
      </div>
    </div>
  );
};

export default PaymentSuccess;
